import React from "react";
import { Navigate } from "react-router-dom";

// Legacy login route -- redirect to new magic link login
const Login = () => {
  return <Navigate to="/auth/login" replace />;
};

export default Login;
